/**
 * Les 3 templates GRAND format (composants forwardRef `{ data }`), instanciés
 * depuis `LargeSheetView` + une palette. Fichier « composants uniquement »
 * (contrat `MenuSheetComponent`, cible `domToPng`).
 */
import { forwardRef } from "react";

import type { MenuSheetData } from "../types";
import { LargeSheetView } from "./LargeSheet";
import { BOUDOIR_LARGE, EDITORIAL_LARGE, POP_LARGE } from "./largePalettes";

export const BoudoirLargeTemplate = forwardRef<HTMLDivElement, { data: MenuSheetData }>(
  function BoudoirLargeTemplate({ data }, ref) {
    return <LargeSheetView ref={ref} data={data} palette={BOUDOIR_LARGE} />;
  },
);

export const EditorialLargeTemplate = forwardRef<HTMLDivElement, { data: MenuSheetData }>(
  function EditorialLargeTemplate({ data }, ref) {
    return <LargeSheetView ref={ref} data={data} palette={EDITORIAL_LARGE} />;
  },
);

export const PopLargeTemplate = forwardRef<HTMLDivElement, { data: MenuSheetData }>(
  function PopLargeTemplate({ data }, ref) {
    return <LargeSheetView ref={ref} data={data} palette={POP_LARGE} />;
  },
);
